import mapValues from 'lodash/mapValues';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { createReducer as createPagerReducer } from 'rp-react-pagination';
import { createReducer as createDataTableReducer } from '../modules/DataTable';
import { createReducer as createDropDownReducer } from '../modules/Dropdown';
import { createReducer as createFilterReducer } from '../modules/Filter';
import { createExpandableRowReducer } from '../reducers/expandableRow';
import createCatalogueReducer from '../reducers/catalogue';
import createShortlistReducer from '../reducers/shortlist';
import relativesSwitcherReducer from '../reducers/relativesSwitcher';
import { createReducer as createGridDataTableReducer } from '../reducers/gridDataTable';
import breakpoints from '../Breakpoints/breakpoints.reducer';

function bindReducers(reducerCreators, stateKey) {
    return mapValues(reducerCreators, reducerCreator => reducerCreator(stateKey));
}
export default combineReducers({
    routing: routerReducer,
    catalogue: createCatalogueReducer('catalogue'),
    shortlist: createShortlistReducer('shortlist'),
    relativesSwitcher: relativesSwitcherReducer,
    catalogues: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        dropDown: createDropDownReducer,
        gridDataTable: createGridDataTableReducer,
    }, 'catalogues')),
    previouslySold: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        pager: createPagerReducer,
    }, 'previouslySold')),
    sires: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        pager: createPagerReducer,
    }, 'sires')),
    vendors: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        pager: createPagerReducer,
    }, 'vendors')),
    relativesResults: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        filter: createFilterReducer,
    }, 'relativesResults')),
    relativesEntries: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        filter: createFilterReducer,
    }, 'relativesEntries')),
    relativesSales: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        filter: createFilterReducer,
    }, 'relativesSales')),
    statistics: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        gridDataTable: createGridDataTableReducer,
        dropDown: createDropDownReducer,
    }, 'statistics')),
    statisticsSalesByDays: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        dropDown: createDropDownReducer,
    }, 'statisticsSalesByDays')),
    statisticsSalesByHorseTypes: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        dropDown: createDropDownReducer,
    }, 'statisticsSalesByHorseTypes')),
    statisticsSires: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        dropDown: createDropDownReducer,
        expandableRow: createExpandableRowReducer,
    }, 'statisticsSires')),
    statisticsBuyers: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        expandableRow: createExpandableRowReducer,
    }, 'statisticsBuyers')),
    statisticsVendors: combineReducers(bindReducers({
        dataTable: createDataTableReducer,
        expandableRow: createExpandableRowReducer,
    }, 'statisticsVendors')),
    breakpoints,
});



// WEBPACK FOOTER //
// ./src/js/reducers/index.js